<template>
  <section class="partners">
    <TheHeader />
    <div class="limit-grid">
      <h1>Nossos parceiros mais perto de você.</h1>
      <SearchBar />
      <div
        class="partners__grid"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="8"
      >
        <ThePartner
          v-for="partner in partners.slice(0, count)"
          :key="partner.CodigoEmpresa"
          :data="partner"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  title() {
    return `Parceiros | Cartão de TODOS Atlético`;
  },
  data() {
    return {
      page: 1,
      count: 4,
    };
  },
  components: {
    SearchBar: () => import('@/components/SearchBar.vue'),
    ThePartner: () => import('@/components/ThePartner.vue'),
  },
  computed: {
    ...mapGetters(['partners']),
  },
  methods: {
    loadMore: function() {
      this.busy = true;
      let total = this.partners.length;

      setTimeout(() => {
        if (total <= total * this.page) {
          this.count += 4;
          this.page++;
        }
        this.busy = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.partners {
  padding-top: 68px;
  padding-bottom: 137px;
  @include media('>=tablet') {
    padding-top: 105px;
  }
  h1 {
    color: $color-black;
    font-family: 'Arvo', sans-serif;
    font-size: 17px;
    line-height: 25px;
    font-weight: 700;
    text-align: center;
    margin: 0 auto;
    padding: 33px 0 0;
    max-width: 195px;
    @include media('>=tablet') {
      font-size: 40px;
      line-height: 49px;
      max-width: initial;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 19px;
    @include media('>=tablet') {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>
